export default function ownerDocument(
  node?: Element | Document | null
): Document {
  return (node && node.ownerDocument) || document
}
